import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import styled, { css } from 'styled-components';
import { colors, typoGraphy } from '../../../stylesheets';

const Text = styled.span`
  color: ${(props) => colors[props.color]};
  font-size: ${(props) => typoGraphy[props.size].fontSize};
  font-weight: ${(props) => typoGraphy[props.size].fontWeight};
  ${(props) =>
    props.pointer &&
    css`
      cursor: pointer;
    `}
`;

function TextWithTooltip(props) {
  const { id, size, color, children, maxCharacter, onClick, pointer } = props;

  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  const handleTruncate = (text, maxCharacter) => {
    if (text.length > maxCharacter) {
      return `${text.slice(0, maxCharacter)}...`;
    } else {
      return text;
    }
  };

  return (
    <div>
      <Text
        size={size}
        color={color}
        id={id}
        onClick={onClick}
        pointer={pointer}
      >
        {handleTruncate(children, maxCharacter)}
      </Text>
      {children.length > maxCharacter ? (
        <Tooltip
          placement="top"
          isOpen={tooltipOpen}
          target={id}
          toggle={toggle}
          autohide={false}
        >
          {children}
        </Tooltip>
      ) : null}
    </div>
  );
}

export default TextWithTooltip;
